import { Route, Switch } from 'react-router';
import AuthRoute from 'components/auth-route';
import Home from 'features/home';
import Users from 'features/users';
import Releases from 'features/releases';
import Login from 'features/login';
import QRDiagnostics from 'features/qr-diagnostics';
import NotFound from 'features/not-found';

export default () => (
  <Switch>
    <AuthRoute exact path="/" component={Home} />
    <AuthRoute path="/releases" component={Releases} />
    <AuthRoute admin path="/users/:id?" component={Users} />
    <AuthRoute path="/qr-diagnostics/:id?" component={QRDiagnostics} />
    <Route path="/login" component={Login} />
    <Route component={NotFound} />
  </Switch>
);
